import { registerPlugin } from '@capacitor/core';
const CallScreen = registerPlugin('CallScreen', {
    web: () => import('./web').then((m) => new m.CallScreenWeb()),
});
export * from './definitions';
export { CallScreen };
//# sourceMappingURL=index.js.map